import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from '../store';
import {
  getToken,
} from '../utils/index';

NProgress.configure({
  showSpinner: false,
});

Vue.use(Router);

// 基础路由
function baseRouter() {
  const index = () =>
    import('../pages/index');
  const login = () =>
    import('../pages/login/login');
  const wxLoading = () =>
    import('../pages/login/wxLoading');
  const jumpLogin = () =>
    import('../pages/login/jumpLogin');

  // const classEdit = () =>
  //     import ('../views/basic/class/Edit');
  const classList = () =>
    import('../views/basic/class/List');

  const adminList = () =>
    import('../views/system/admin/List');
  const adminEdit = () =>
    import('../views/system/admin/Edit');
  const roleEdit = () =>
    import('../views/system/role/Edit');
  const roleList = () =>
    import('../views/system/role/List');
  // const reprewhiteList = () =>
  //   import('../views/reprewhiteList/reprewhiteList/List');
  const pwdUpdate = () =>
    import('../views/system/Update');

  // const groupList = () =>
  //     import ('../views/system/group/List');
  // const groupEdit = () =>
  //     import ('../views/system/group/Edit');
  // const groupUser = () =>
  //     import ('../views/system/group/User');
  // const messageList = () =>
  //     import ('../views/system/message/List');
  // const messageEdit = () =>
  //     import ('../views/system/message/Edit');

  // 基础router
  return [{
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      title: '登录',
      notAuth: true,
    },
  },{
    path: '/wxLoading',
    name: 'wxLoading',
    component: wxLoading,
    meta: {
      title: '企业微信登录',
      notAuth: true,
    },
  },{
    path: '/jumpLogin',
    component: jumpLogin,
    meta: {
      title: '企业微信扫码登录',
      notAuth: true,
    }
  }];
}

// router对象工厂
function routerFactory() {
  const routers = baseRouter();

  const routerObj = new Router({
    routes: routers,
  });

  const whiteList = ['/login', '/wxLoading', '/jumpLogin']// no redirect whitelist

  // 全局router守卫
  routerObj.beforeEach(async (to, from, next) => {
    console.log(8800);
    NProgress.start();
    console.log(11);
    if (to.path === '/login') {
      store.commit('clearArr');
      next();
    } else {
      // 获取token
      console.log(22);
      const token = getToken('token');
      if (whiteList.indexOf(to.path) == -1 && token) {
        // 如果to.path在前端路由并且在菜单权限里就跳转，否则跳转到第一个菜单路由即第一个path
        if (store.getters.menuList.length === 0 || store.getters.permissions.length === 0 || store.getters.routes.length === 0) {
          const router = await store.dispatch('initMenu');
          // routerObj.matcher = new Router({}).matcher;
          routerObj.options.routes = routers;
          routerObj.addRoutes(router);
          routerObj.options.routes = routerObj.options.routes.concat(router);
          next({
            ...to,
            replace: true,
          });
          NProgress.done();
          console.log(55);
        } else {
          const pathList = store.getters.routes;
          const exist = pathList.find(path => path === to.path);
          if (exist) {
            console.log(66);
            next();
          } else {
            console.log(77);
            const res = store.getters.menuList.find(item => item.path === '/home');
            if (res) {
              next({
                path: res.path,
              });
              NProgress.done();
            } else {
              next({
                path: store.getters.menuList[0].children[0].path,
              });
              NProgress.done();
            }
          }
        }
      } else {
        if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
          console.log('login');
          next()
        } else {
          next({
            path: '/login',
          });
          // next();
          NProgress.done();
          console.log(33);
        }
      }
    }
    // 设置页面标题
    // document.title = '中国简糖行动';
    // document.title = '医生站年终盘点';
    document.title = '后台管理';
  });

  routerObj.afterEach(() => {
    NProgress.done();
  });

  routerObj.onReady(() => {});

  return routerObj;
}

export default routerFactory();



// WEBPACK FOOTER //
// ./src/router/index.js